const asyncActionType = type => ({
  pending: `${type}/PENDING`,
  success: `${type}/SUCCESS`,
  error: `${type}/ERROR`
});

const GET_DIRECTORY = asyncActionType('aerosimple/documents/GET_DIRECTORY');
const GET_DIRECTORY_DETAIL = asyncActionType('aerosimple/documents/GET_DIRECTORY_DETAIL');

export {
  GET_DIRECTORY,
  GET_DIRECTORY_DETAIL
};
